module.exports = __webpack_public_path__ + "static/img/rank_293.89a401c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_293.png
// module id = oSM9
// module chunks = 1